import React, { useContext } from 'react';
import { Alert, Box, TextField } from '@mui/material';
import CartContext from '../../../contexts/CartContext';
import { useCustomer } from '../../../contexts/CustomerContext';

// Shown above Step 1 of checkout when the signed-in customer is making
// their first paid order. Lets them enter a friend's code; server awards
// the code owner if it resolves. The input writes straight to cart.friendCode
// (persisted in localStorage); checkout submission picks it up automatically.
//
// Hidden once the customer has placed any paid order (friendCode.first_purchase
// goes false). Also hidden for guests — they have no customer record, so the
// referral can't be attributed.
const FriendCodeInput: React.FC = () => {
  const { cart, setCartState } = useContext(CartContext);
  const { friendCode } = useCustomer();

  if (!friendCode || !friendCode.first_purchase) return null;

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setCartState({
      ...cart,
      // Empty string normalizes to undefined so the cart never carries
      // an empty value through to the checkout payload.
      friendCode: val.trim() === '' ? undefined : val,
    });
  };

  return (
    <Alert
      icon={false}
      severity="success"
      sx={{ mb: 2, alignItems: 'center' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box>
          <strong>Have a friend code?</strong> Enter it below — your friend
          earns points on your first order.
        </Box>
        <TextField
          value={cart.friendCode ?? ''}
          onChange={onChange}
          placeholder="e.g. K9R2-T4XP"
          size="small"
          inputProps={{
            style: { fontFamily: 'monospace', letterSpacing: '0.05em' },
            maxLength: 16,
          }}
          sx={{ maxWidth: 220, backgroundColor: 'background.paper' }}
        />
      </Box>
    </Alert>
  );
};

export default FriendCodeInput;
